import axios from "axios";
const BACKEND_URL = 'https://gestapo.sisc.ro/api';
// axios.defaults.baseURL = "https://gestapo.sisc.ro/api/";

export const userApi = {
  getCurrentUser: async () => {
    const response = await axios.get(`${BACKEND_URL}/user/getCurrentUser`, {
      withCredentials: true,
    })
    return response;
  }
};

export const bandApi = {
  getAllBands: async () => {
    const response = await axios.get(`${BACKEND_URL}/band/all`, {
      withCredentials: true,
    });
    return response;
  },
  countBands: async () => {
    const response = await axios.get(`${BACKEND_URL}/band/countBands`, {
      withCredentials: true,
    });
    return response;
  },
  getProfessionals: async () => {
    const response = await axios.get(`${BACKEND_URL}/band/getProfessionals`, {
      withCredentials: true,
    });
    return response;
  },
  getAmateurs: async () => {
    const response = await axios.get(`${BACKEND_URL}/band/getAmateurs`, {
      withCredentials: true,
    });
    return response;
  },
  getBandById: async (bandId) => {
    const response = await axios.get(`${BACKEND_URL}/band/${bandId}`, {
      withCredentials: true,
    });
    return response; 
  },
  updateBand: async (newBand, bandId) => {
    const response = await axios.put(`${BACKEND_URL}/band/updateBand/${bandId}`, newBand, {
      withCredentials: true,
    });
    return response;
  },
  deleteBand: async (bandId) => {
    const response = await axios.delete(`${BACKEND_URL}/band/${bandId}`, {
      withCredentials: true,
    });
    return response;
  },
};

export const playApi = {
  updatePlay: async (newPlay, playId) => {
    const response = await axios.patch(`${BACKEND_URL}/play/updatePlay/${playId}`, newPlay, {
      withCredentials: true,
    });
    return response;
  }
}
